module.exports = "/restaurants/rest1.jpg?Hwy3FGA";